import { mapGetters, mapState } from "vuex"

import misc_utilities from "./MiscUtilities"

const profile_utilities = {
    mixins: [misc_utilities],
    methods: {
        role_is (role_id, role) {
            const role_id_as_int = parseInt(role_id)
            if(`${role_id_as_int}` === `${role_id}`) return (role_id === role.id)
            return (role_id === role.name)
        },
        role_is_assistant (role_id) {
            return this.role_is(role_id, this.constants("roles", "ROLE_ASSISTANT"))
        },
        role_is_administrator (role_id) {
            return this.role_is(role_id, this.constants("roles", "ROLE_ADMIN"))
        },
        role_is_developer (role_id) {
            return this.role_is(role_id, this.constants("roles", "ROLE_DEVELOPER"))
        },
        role_is_at_least_administrator (role_id) {
            return this.role_is_developer(role_id) || this.role_is_administrator(role_id)
        },
        role_is_at_least_assistant (role_id) {
            return this.role_is_at_least_administrator(role_id) || this.role_is_assistant(role_id)
        },
        role_label (role) {
            if((typeof role === "string") || (role && role.name)) return this.nibnut_filter("nibnut.ucwords", [role.name || role])
            return role
        },
        profile_subscribed (profile) {
            if(!profile) return false
            if(this.role_is_at_least_assistant(profile.role_id)) return true
            return !!profile.has_access
        }
    },
    computed: {
        ...mapState(["profile_id"]),
        ...mapGetters(["entity_records"]),
        raw_user_records () {
            return this.entity_records("user")
        },
        profile () {
            return this.raw_user_records.find(user => user.id === this.profile_id) || {}
        },
        subscribed () {
            return this.profile_subscribed(this.profile)
        },
        is_at_least_assistant () {
            return this.is_assistant || this.is_administrator || this.is_developer
        },
        is_at_least_administrator () {
            return this.is_administrator || this.is_developer
        },
        is_assistant () {
            if(!this.profile_id) return false
            return this.role_is_assistant(this.profile.role_id)
        },
        is_administrator () {
            if(!this.profile_id) return false
            return this.role_is_administrator(this.profile.role_id)
        },
        is_developer () {
            if(!this.profile_id) return false
            return this.role_is_developer(this.profile.role_id)
        },
        is_app_user () {
            return !!this.$cookie.get("nibnut-app-user")
        }
    }
}

export default profile_utilities
